import { clsx } from "clsx";

export function fmtDate(iso, opts) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { timeZone: "Europe/London", ...(opts || { day: "numeric", month: "short", year: "numeric" }) });
  } catch { return "—"; }
}

export function fmtTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("en-GB", { timeZone: "Europe/London", hour: "numeric", minute: "2-digit", hour12: true });
  } catch { return ""; }
}

export function daysUntil(iso) {
  if (!iso) return null;
  return Math.ceil((new Date(iso) - new Date()) / 86400000);
}

export const statusStyles = {
  compliant: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400 border-emerald-200 dark:border-emerald-500/30",
  expiring: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400 border-amber-200 dark:border-amber-500/30",
  overdue: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400 border-red-200 dark:border-red-500/30",
  pending: "bg-slate-100 text-slate-600 dark:bg-slate-500/15 dark:text-slate-300 border-slate-200 dark:border-slate-500/30",
  registered: "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400 border-blue-200 dark:border-blue-500/30",
  waitlisted: "bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-400 border-violet-200 dark:border-violet-500/30",
  completed: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400 border-emerald-200 dark:border-emerald-500/30",
  no_show: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400 border-red-200 dark:border-red-500/30",
  approved: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400 border-emerald-200 dark:border-emerald-500/30",
};

export const modeIcons = {
  online: "Monitor",
  classroom: "Building2",
  blended: "Layers",
  virtual: "Video",
};

export const categoryColors = {
  Compliance: "bg-blue-500",
  Technical: "bg-violet-500",
  Leadership: "bg-amber-500",
  Safety: "bg-red-500",
};

export function cx(...a) { return clsx(...a); }

export function initials(name) {
  if (!name) return "U";
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}
